import {
  SET_VALUE_WEB_MANAGEMENT,
  DELETE_ALL_VALUES_WEB_MANAGEMENT,
} from "../../constants/types";

export const setValueWebManagement = payload => {
  return {
    type: SET_VALUE_WEB_MANAGEMENT,
    payload,
  };
};

export const deleteAllValuesWebManagement = () => {
  return {
    type: DELETE_ALL_VALUES_WEB_MANAGEMENT,
  };
};
